import styles from './AdminRegularTaxInvoiceInfo.module.css'
import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {GetRegularTaxInvoiceResponseData} from "../../../types/admin";
import {useAlert} from "../../common/error/AlertContext";
import {
    deleteRegularAdminTaxInvoiceAPI, getRegularTaxInvoiceInfoAPI
} from "../../../services/admin";
import Button from "../../common/button/Button";
import TextCard from "../../common/textCard/TextCard";

interface AdminTaxInvoiceInfoProps {
    taxInvoiceId: number;
}
const AdminRegularTaxInvoiceInfo: React.FC<AdminTaxInvoiceInfoProps> = ({taxInvoiceId}) => {
    const {id} = useParams();
    const [data, setData] = useState<GetRegularTaxInvoiceResponseData | null>(null);
    const [loading, setLoading] = useState(true);
    const {showAlert} = useAlert();
    const navigate = useNavigate();

    //수정
    const handleModifyClick = () => {
        navigate(`/admin/billing/regular/edit/${id}`)
    };

    //세금게산서 삭제
    const handleDelete = async () => {
        try {
            await deleteRegularAdminTaxInvoiceAPI(taxInvoiceId);
            navigate("/admin/billing");
            showAlert('세금계산서가 삭제되었습니다.', 'info');
        } catch (error) {
            console.error('Error fetching payment info:', error);
            showAlert('결제 정보를 불러오는데 실패했습니다.', 'error');
        }
    };

    //데이터 세팅
    const fetchData = async () => {
        if (!id) return;
        try {
            setLoading(true);
            const response = await getRegularTaxInvoiceInfoAPI(parseInt(id));
            setData(response);
        } catch (error) {
            console.error('Error fetching payment info:', error);
            showAlert('정기발행 정보를 불러오는데 실패했습니다.', 'error');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [id]);

    //발행 데이터
    const getRegularTaxInvoiceInfo = () => {
        if (!data) return [];
        return [
            {
                label: "회사명",
                value: data.companyName
            },
            {
                label: "정기 발행일",
                value: "매월 " + data.day.toString() + "일"
            }
        ];
    };

    //금액 데이터
    const getAmountInfo = () => {
        if (!data) return [];
        return [
            {
                label: "공급가액",
                value: (data.amount / 11 * 10).toLocaleString() + "원"
            },
            {
                label: "세액",
                value: (data.amount / 11).toLocaleString() + "원"
            },
            {
                label: "총액",
                value: data.amount.toLocaleString() + "원"
            }
        ];
    };


    if (loading) {
        return <div className={styles.loading}>Loading...</div>;
    }

    if (!data) {
        return <div className={styles.error}>세금계산서 정보를 찾을 수 없습니다.</div>;
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h2 className={styles.title}>세금계산서 상세 정보</h2>
                {/*임시저장 상태일 경우 발행, 수정, 삭제 버튼 출력*/}
                <div className={styles.buttons}>
                    <Button
                        variant="secondary"
                        onClick={handleModifyClick}
                        size="small"
                    >
                        수정
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={handleDelete}
                        size="small"
                    >
                        삭제
                    </Button>
                </div>
            </div>
            <div className={styles.textContainer}>
                <TextCard items={getRegularTaxInvoiceInfo()}/>
                <TextCard items={getAmountInfo()}/>
            </div>
        </div>
    );
};

export default AdminRegularTaxInvoiceInfo